import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '../../types/location.type';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AddressComponent {
  showRideId = environment.features.showTripId;

  @Input() location: Location | undefined = undefined;
  @Input() phoneNumber: string = '';
  @Input() inline = false;
  @Input() small = false;
  @Input() rideId = '';
}
